import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "@/components/ui/table";
import {ITableColumn, ITableComponentProps} from "@/models/table.model";
import "./TableComponent.scss";
import {ReactNode} from "react";
import StatusCardComponent from "@/components/common-components/status-card/StatusCardComponent.tsx";
import LoaderComponent from "@/components/common-components/loader/LoaderComponent.tsx";

interface TableComponentProps extends ITableComponentProps {
    loading?: boolean;
    errored?: boolean;
    id?: string;
    columns: ITableColumn[];
    data: any[];
    metaInfo?: any;
    noDataText?: string;
    className?: string;
    errorText?: string;
}

const TableComponent = (props: TableComponentProps) => {
    const {
        columns,
        errorText,
        metaInfo,
        data,
        noDataText,
        className,
        rowClassName,
        rowKey,
        loading,
        errored
    } = props;

    return (
        <div className={`shadcn-table-component relative overflow-x-auto ${className ?? ""}`}>
            <Table className={"sticky"}>
                <TableHeader>
                    <TableRow className="table-bg">
                        {columns.map((column) => (
                            <TableHead
                                key={column.key}
                                className={column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'}
                                style={{width: column.width, maxWidth: column.maxWidth}}
                            >
                                {column.title}
                            </TableHead>
                        )) as ReactNode}
                    </TableRow>
                </TableHeader>

                <TableBody className={'shadcn-table-body'}>
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <TableRow
                                key={rowKey ? rowKey(row) : row.code ?? index}
                                className={rowClassName ? rowClassName(row) : ''}
                            >
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.key}
                                        className={column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'}
                                        style={{width: column.width, maxWidth: column.maxWidth}}
                                    >
                                        {column.render ? column.render(row, index, metaInfo) : row[column.key]}
                                    </TableCell>
                                )) as ReactNode}
                            </TableRow>
                        ) as ReactNode)
                    ) : !(loading || errored) && (
                        <TableRow>
                            <TableCell colSpan={columns.length}>
                                <div className="table-no-data-wrapper">
                                    <StatusCardComponent
                                        id="status_card"
                                        title={noDataText ? noDataText : "No data found"}
                                        className="table-data-not-found-card"
                                    />
                                </div>
                            </TableCell>
                        </TableRow>
                    ) as ReactNode}

                    {
                        loading && (<TableRow>
                            <TableCell colSpan={columns.length}>
                                <div className="table-no-data-wrapper">
                                    <LoaderComponent type="spinner"/>
                                </div>
                            </TableCell>
                        </TableRow> as ReactNode)
                    }

                    {errored && (
                        <TableRow>
                            <TableCell colSpan={columns.length}>
                                <div className="table-no-data-wrapper">
                                    <StatusCardComponent
                                        id="status_card"
                                        title={errorText ? errorText : "Failed to load data"}
                                        className="table-data-not-found-card"
                                    />
                                </div>
                            </TableCell>
                        </TableRow>
                    ) as ReactNode}
                </TableBody>
            </Table>
        </div>
    );
};

export default TableComponent;
